/* eslint-disable no-console */
import React from 'react';
import styled from 'styled-components';
import { SuperAdminLayout } from 'Components/Layout/SuperAdminLayout';
import SuperAdminUserManagementComponent from 'Components/SuperAdminPage/OrganizationManagement/OrganizationDetails';
import { useParams } from 'react-router-dom';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const SuperAdminUserManagement = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  return (
    <SuperAdminLayout>
      <ContentContainer>
        <SuperAdminUserManagementComponent
          organizationId={Number(organizationId)}
        />
      </ContentContainer>
    </SuperAdminLayout>
  );
};
export default SuperAdminUserManagement;
